'use strict';
import React from 'react';
import classnames from 'classnames';
import fx from 'utils/effects';

var LoginSlideshow = React.createClass({

    displayName: 'LoginSlideshow',

    propTypes: {
        show: React.PropTypes.array,
        speed: React.PropTypes.number
    },

    getInitialState() {
        return {
            activeSlideIdx: 0
        };
    },

    componentDidMount() {
        if (this.props.show || this.props.show.length > 0) {
            this.initFirstSlide();
            if (this.props.show.length > 1) {
                this.startAnimation();
            }
        }
    },

    initFirstSlide() {
        if (this.refs.slide_0) {
            var curEl = this.refs.slide_0.getDOMNode();
            fx.fadeInOut(curEl, 'in');
        }
    },

    startAnimation() {
        this.interval = window.setInterval(function() {
            var curIdx = this.state.activeSlideIdx;
            var nextIdx = (this.state.activeSlideIdx === (this.props.show.length - 1)) ? 0 : (this.state.activeSlideIdx + 1);

            var curEl = this.refs['slide_' + curIdx].getDOMNode();
            var nextEl = this.refs['slide_' + nextIdx].getDOMNode();

            fx.fadeInOut(curEl, 'out');
            fx.fadeInOut(nextEl, 'in');

            this.setState({
                activeSlideIdx: nextIdx
            });

        }.bind(this), (this.props.speed ? parseInt(this.props.speed, 10) : 2000));
    },

    componentWillUnmount() {
        window.clearInterval(this.interval);
    },

    renderSlides() {
        var slides = [];

        this.props.show.map((slideNode, index) => {
            slides.push(
                <div
                    className={
                        classnames(
                            'slideshow__item',
                            {'active': index === this.state.activeSlideIdx}
                        )
                    }
                    ref={'slide_' + index}
                    key={index}
                    style={{
                        'backgroundImage': 'url(' + slideNode + ')',
                        'opacity': 0}}/>
            );
        });

        return slides;
    },

    render() {
        if (!this.props.show || this.props.show.length === 0) {
            return false;
        }
        return (
            <div className="login__slideshow">
                {this.renderSlides()}
            </div>
        );
    }
});

module.exports = LoginSlideshow;



// WEBPACK FOOTER //
// ./app/pages/login/loginSlideshow.jsx